exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".background{\r\n\tbackground: #E5E5E5;\r\n\t/* min-height should be removed */\r\n\tmin-height: 400px;\r\n}\r\n.bar-style{\r\n\theight: 50px;\r\n\tbackground-color: #006496;\r\n\tcolor: #fff;\r\n\tline-height: 330%;\r\n}\r\n.bar-style a{\r\n\tcolor: #fff;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/src/app/create-agency/create-agency.component.css
// module id = ../../../../../src/app/create-agency/create-agency.component.css
// module chunks = 1